import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined, FileExcelOutlined
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import ProductForm from "../forms/Product";
import UploadForm from "../forms/Upload";
import ProductView from "../views/Product";
const { TextArea } = Input;


class ProductsWaitPage extends Component {

  
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      mainCats: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      subCats: [],
      tags: [],
      packages: [],
      exelFile: null,
      uploadLoading: false,

      // موارد جدید
      visibleStatusModal: false,
      statusProduct: null,
      productStatus: 0,
      rejectReason: "",
      statusSubmitting: false,


       supplierId: null,
      suppliers: [],
      supplierSearchLoading: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterCheckBox, filterMainCat, filterSubCat, filterSearch, supplierId } =
      this.state;
      params.search_type = "wait"

    if (filterSearch) params.q = SearchFormat(filterSearch);

    if (filterCheckBox) {
      const filter = filterCheckBox.join(",");
      params.image = filter.indexOf("img") >= 0 ? 1 : 0;
      params.category = filter.indexOf("cat") >= 0 ? 1 : 0;
      params.code = filter.indexOf("cod") >= 0 ? 1 : 0;
      params.isVip = filter.indexOf("vip") >= 0 ? 1 : 0;
      params.hasPrice = filter.indexOf("hasPrice") >= 0 ? 1 : 0;
    }

    if (supplierId) {
      params.supplier_id = supplierId;
    }
    if (filterSubCat) params.subCategoryId = filterSubCat;
    else if (filterMainCat) params.categoryId = filterMainCat;

    this.setState({ loading: true });

    API.product
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });

    setTimeout(() => {
      this.formRef.current.handleDidMount(product);
    }, 0);
  };

  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  showUpload = (product = {}) => {
    this.setState({ visibleUpload: true, selected: product });

    setTimeout(() => {
      this.uploadRef.current.handleDidMount(product.id);
    }, 0);
  };

  hideUpload = () => {
    this.setState({ visibleUpload: false });

    setTimeout(() => {
      this.uploadRef.current.handleWillUnmount();
    }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleUpload = (values) => {
    this.setState({ submitting: true });

    API.product
      .addImage(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideUpload();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  showStatusModal = (record) => {
    this.setState({
      visibleStatusModal: true,
      statusProduct: record,
      productStatus: Number(record.status),
      rejectReason: record.reject_reason || "",
    });
  };

  hideStatusModal = () => {
    this.setState({
      visibleStatusModal: false,
      statusProduct: null,
      productStatus: 0,
      rejectReason: "",
      statusSubmitting: false,
    });
  };

  handleStatusSubmit = () => {
    const {
      statusProduct,
      productStatus,
      rejectReason,
    } = this.state;

    if (!statusProduct) {
      return;
    }

    // برای وضعیت رد شده، دلیل اجباری باشد
    if (Number(productStatus) === -1 && !rejectReason.trim()) {
      message.error("لطفاً دلیل رد محصول را وارد کنید.");
      return;
    }

    this.setState({ statusSubmitting: true });

    const payload = {
      status: Number(productStatus),
      reject_reason:
        Number(productStatus) === -1 ? rejectReason.trim() : null,
    };

    API.product
      .statusUpdate(statusProduct, payload)
      .then((result) => {
        message.success(result.message);

        this.hideStatusModal();

        this.fetch({
          page: this.state.pagination.current,
        });
      })
      .catch(() => {
        this.setState({ statusSubmitting: false });
      });
  };


  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteImage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.product
          .deleteImage(record.id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    if(this.state.selected.id != undefined){
      API.product
          .update(values, this.state.selected.id)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }else{
      API.product
          .save(values)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }

  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    API.category.list({ type: "main" }).then((result) => {
      this.setState({ mainCats: result.data });
    });

    API.category.list({ type: "sub" }).then((result) => {
      this.setState({ subCats: result.data });
    });

    API.tag.list().then((result) => {
      this.setState({ tags: result.data });
    });
    API.package.list().then((result) => {
      this.setState({ packages: result.data });
    });

    if (catId && subCatId) {
      this.setState({
        filterMainCat: parseInt(catId),
        filterSubCat: parseInt(subCatId),
      });
    }

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  }

  handleUploadFile = async () => {
    this.setState({ uploadLoading: true });
    const formData = new FormData();
    formData.append("file", this.state.exelFile);
    try {
      const data = await API.product.excelUpload(formData);
      console.log(data);
    } catch (error) {
      console.log("Error :");
      console.log(error);
      this.setState({ uploadLoading: false });
      if (error.status === true) {
        message.success(`فایل ${this.state.exelFile.name} با موفقیت آپلود شد.`);
        this.setState({ exelFile: null });
      } else {
        message.error("فایل آپلود نشد. دقت شود فایل از نوع اکسل باشد");
      }
    }
  };



  handleSupplierSearch = (value) => {
    const search = value.trim();

    if (!search) {
      this.setState({
        suppliers: [],
        supplierSearchLoading: false,
      });

      return;
    }

    this.setState({ supplierSearchLoading: true });

    API.user
      .search({
        q: SearchFormat(search),
      })
      .then((result) => {

        const users = Array.isArray(result.data)
          ? result.data.data || result.data
          : [];

        this.setState({
          suppliers: users,
          supplierSearchLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          suppliers: [],
          supplierSearchLoading: false,
        });
      });
  };

  handleSupplierChange = (value) => {
    this.setState(
      {
        supplierId: value || undefined,
      },
      () => {
        this.fetch({
          page: 1,
        });
      }
    );
  };

  // download excel for mahak

  handleExportExcel = (params = {}) => {
      const { filterCheckBox, filterMainCat, filterSubCat, filterSearch, supplierId } =
      this.state;

       params.search_type = "wait"
    if (filterSearch) params.q = SearchFormat(filterSearch);

    if (supplierId) {
      params.supplier_id = supplierId;
    }
    if (filterSubCat) params.subCategoryId = filterSubCat;
    else if (filterMainCat) params.categoryId = filterMainCat;
    


    this.setState({ loading: true });

    API.product
        .excelExport(params)
        .then((response) => {
            this.setState({ loading: false });

            // اگر لاراول ["status" => 1, "url" => "..."] برگردانده باشد:
            if (response && response.url) {
                
                const link = document.createElement('a');
                link.href = response.url;
                link.target = '_blank'; // باز کردن در تب جدید
                
                // اضافه کردن به بدنه صفحه و کلیک کردن روی آن
                document.body.appendChild(link);
                link.click();
                
                // حذف المان از صفحه بعد از کلیک
                document.body.removeChild(link);
                
                message.success("فایل اکسل در حال دانلود است...");
            } else {
                message.error("خطا در دریافت لینک فایل از سرور");
            }
        })
        .catch((error) => {
            this.setState({ loading: false });
            message.error("خطا در عملیات خروجی اکسل");
            console.error("Export Error:", error);
        });
};

  // end of download excel for mahak

  render() {
    const {
      data,
      filterMainCat,
      loading,
      mainCats,
      pagination,
      selected,
      subCats,
      submitting,
      tags,
      visibleDrawer,
      visibleModal,
      visibleUpload,
      exelFile,
      packages,
        // موارد جدید
      visibleStatusModal,
      statusProduct,
      productStatus,
      rejectReason,
      statusSubmitting,

      supplierId,
      suppliers,
      supplierSearchLoading,


      
    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "name",
      },

      {
        title: Resources.supplier,
        dataIndex: "supplier",
        render: (val) => (val ? `${val.name || ""} ${val.family || ""} - ${val.phone || ""}` : "-")

      },
      {
        title: Resources.category,
        dataIndex: "category",
        className: "col-center",
        render: (val, record) => {
          let str = "-";

          if (val) {
            str = val.name;

            if (record.sub_category) {
              str = `${str} / ${record.sub_category.name}`;
            }
          }

          return str;
        },
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "130px",
      },
      {
        title: Resources.inventory,
        dataIndex: "inventory",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.price,
        dataIndex: "priceOne",
        className: "col-center",
        render: (val, record) =>
          `${PriceFormat(val)}/${PriceFormat(record.priceTwo)}/${PriceFormat(
            record.priceThree
          )}`,
      },
      {
        title: Resources.status,
        dataIndex: "status",
        className: "col-center",
        width: "70px",
        render: (val, record) => {
            const status = Number(val);

            let title = "در انتظار تأیید";
            let color = "#faad14";

            if (status === 1) {
              title = "تأیید شده";
              color = "#52c41a";
            } else if (status === -1) {
              title = "رد شده";
              color = "#ff4d4f";
            }

            return (
              <Button
                type="link"
                size="small"
                onClick={() => this.showStatusModal(record)}
                disabled={!permissions.action}
                style={{
                  color,
                  padding: 0,
                }}
              >
                {title}
              </Button>
            );
          },


      },
     
    ];

    const subColumns = [
      {
        title: Resources.images,
        dataIndex: "image",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`${Constants.imagePathProduct}${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`${Constants.imagePathProduct}${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
    ];

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.productswaitToMahak}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
            <Col xs={24} md={5}>
              <Select
                defaultValue={catId ? parseInt(catId) : undefined}
                filterOption
                onChange={(value) => this.handleFilter(value, "filterMainCat")}
                placeholder={Resources.filterByMainCat}
                optionFilterProp="name"
                style={{ display: "block" }}
                showSearch
                allowClear
              >
                {mainCats.map((cat) => (
                  <Select.Option key={cat.id} value={cat.id} name={cat.name}>
                    {cat.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} md={5}>
              <Select
                defaultValue={subCatId ? parseInt(subCatId) : undefined}
                filterOption
                onChange={(value) => this.handleFilter(value, "filterSubCat")}
                placeholder={Resources.filterBySubCat}
                optionFilterProp="name"
                style={{ display: "block" }}
                showSearch
                allowClear
              >
                {subCats
                  .filter((o) => parseInt(o.subCategory) === filterMainCat)
                  .map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.name}>
                      {cat.name}
                    </Select.Option>
                  ))}
              </Select>
            </Col>

            <Col>
            </Col>
            <Col xs={24} md={5}>
              <Tooltip title={Resources.searchHintProduct}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
        <Col xs={24} md={5}>
          <Select
            showSearch
            allowClear
            placeholder="فیلتر بر اساس تأمین‌کننده"
            style={{ display: "block", width: "100%" }}
            filterOption={false}
            onSearch={this.handleSupplierSearch}
            onChange={this.handleSupplierChange}
            loading={supplierSearchLoading}
            value={supplierId}
            notFoundContent={
              supplierSearchLoading ? "در حال جستجو..." : "موردی یافت نشد"
            }
          >
            {suppliers.map((supplier) => (
              <Select.Option
                key={supplier.id}
                value={supplier.id}
              >
                {supplier.name} {supplier.family}
              </Select.Option>
            ))}
          </Select>
        </Col>

        {/* <Col xs={24} md={4}>
              <Button 
                type="primary" 
                icon={<FileExcelOutlined />} 
                onClick={this.handleExportExcel} 
                block
                style={{ backgroundColor: '#2e7d32', borderColor: '#2e7d32' }}
              >
                خروجی اکسل
              </Button>
            </Col> */}


           
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  columns={subColumns}
                  dataSource={record.gallery}
                  pagination={false}
                  rowKey="id"
                />
              ),
              rowExpandable: (record) => !!record.gallery.length,
            }}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
        <ProductView
          data={selected}
          visible={visibleDrawer}
          onClose={this.hideDrawer}
        />
        <ProductForm
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}
          mainCats={mainCats}
          subCats={subCats}
          tags={tags}
          packages={packages}
        />
        <UploadForm
          ref={this.uploadRef}
          onCancel={this.hideUpload}
          onSubmit={this.handleUpload}
          submitting={submitting}
          visible={visibleUpload}
        />


        {/* manage product status */}
          <Modal
            title="تغییر وضعیت محصول"
            open={visibleStatusModal}
            onCancel={this.hideStatusModal}
            onOk={this.handleStatusSubmit}
            okText="ذخیره"
            cancelText="انصراف"
            confirmLoading={statusSubmitting}
            destroyOnClose
          >
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 500,
                }}
              >
                وضعیت محصول
              </label>

              <Select
                value={productStatus}
                onChange={(value) =>
                  this.setState({
                    productStatus: Number(value),
                  })
                }
                style={{ width: "100%" }}
              >
                <Select.Option value={0}>
                  در انتظار تأیید
                </Select.Option>

                <Select.Option value={1}>
                  تأیید شده
                </Select.Option>

                <Select.Option value={-1}>
                  رد شده
                </Select.Option>
              </Select>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 500,
                }}
              >
                دلیل رد
              </label>

              <TextArea
                rows={4}
                value={rejectReason}
                onChange={(event) =>
                  this.setState({
                    rejectReason: event.target.value,
                  })
                }
                placeholder="دلیل رد محصول را وارد کنید"
                disabled={Number(productStatus) !== -1}
              />
            </div>

            {statusProduct && (
              <div style={{ marginTop: 12, color: "#888" }}>
                محصول: {statusProduct.name}
              </div>
            )}
          </Modal>

        {/* end of manage product status */}
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(ProductsWaitPage);
